/**
 * EventBranding — displays the organiser's branding image if present.
 *
 * Props:
 *   imageUrl: string | null — the branding image URL (e.g. "/api/branding/{id}/image")
 *   eager: boolean — true for above-the-fold (join screen), false for lazy loading
 *
 * Renders nothing when imageUrl is null/undefined.
 * Max height: 80px mobile, 120px desktop. Centred, keeps proportions.
 * Shows "Powered by Fore Tour" below the image.
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export default function EventBranding({ imageUrl, eager = false }) {
  if (!imageUrl) return null;

  const fullUrl = imageUrl.startsWith('http') ? imageUrl : `${API_BASE}${imageUrl}`;

  return (
    <div className="flex flex-col items-center py-3" data-testid="event-branding">
      <img
        src={fullUrl}
        alt="Event branding"
        crossOrigin="anonymous"
        decoding="async"
        loading={eager ? 'eager' : 'lazy'}
        className="max-h-[80px] sm:max-h-[120px] w-auto object-contain"
        data-testid="event-branding-img"
      />
      <p className="text-[10px] text-[#8A9BA3] mt-1.5">Powered by Fore Tour</p>
    </div>
  );
}
